import { DropdownItem } from '../types/ViewModel/DropdownItem';
import { DropdownItemEventTypeInput } from '../types/ViewModel/DropdownItemEventTypeInput';
import { DropdownItemEventTypeInputFactory } from './DropdownItemEventTypeInputFactory';
import { DropdownItemBM } from '../types/BusinessModel/DropdownItemBM';

export class DropdownItemFactory {
    private dropdownItemEventTypeInputFactory = new DropdownItemEventTypeInputFactory();

    constructor() {}

    private compareItemOrder(a: DropdownItem, b: DropdownItem, desc: boolean): number {
        let cmp: number = 0;
        if (a.itemOrder > b.itemOrder) {
            cmp = 1;
        } else if (b.itemOrder > a.itemOrder) {
            cmp = -1;
        }
        return desc ? cmp * -1 : cmp;
    }

    public newDropdownItem(dropdownItem: DropdownItemBM): DropdownItem {
        const dropdownItemArray: DropdownItemEventTypeInput[] = [];
        if (dropdownItem.dropdownItemEventTypeInputList) {
            dropdownItem.dropdownItemEventTypeInputList.map((dieti) =>
                dropdownItemArray.push(this.dropdownItemEventTypeInputFactory.newDropdownItemEventTypeInput(dieti))
            );
        }
        return new DropdownItem(
            dropdownItem.dropdownItemId,
            dropdownItem.dropdownGroupId,
            dropdownItem.name,
            dropdownItem.itemOrder,
            dropdownItem.deleted,
            dropdownItemArray
        );
    }

    public newDropdownItemFromCode(dropdownItemId: number, dropdownGroupId: number, name: string, itemOrder: number, deleted: boolean): DropdownItem {
        return new DropdownItem(dropdownItemId, dropdownGroupId, name, itemOrder, deleted, []);
    }

    public createDropdownItemArray(dropdownItemArray: DropdownItem[]): DropdownItem[] {
        let drItemArray: DropdownItem[] = [];
        if (dropdownItemArray && dropdownItemArray.length > 0) {
            dropdownItemArray.map((dieti) => dropdownItemArray.push(this.createDropdownItem(dieti)));
            drItemArray = drItemArray.sort((a, b) => this.compareItemOrder(a, b, false));
        }
        return drItemArray;
    }

    public createDropdownItem(dropdownItem: DropdownItem): DropdownItem {
        return new DropdownItem(
            dropdownItem.dropdownItemId,
            dropdownItem.dropdownGroupId,
            dropdownItem.name,
            dropdownItem.itemOrder,
            dropdownItem.deleted,
            this.dropdownItemEventTypeInputFactory.createDropdownItemEventTypeInputArray(dropdownItem.dropdownItemEventTypeInputArray)
        );
    }

    public newDropdownItemFromCodeInput(
        dropdownItemId: number,
        dropdownGroupId: number,
        name: string,
        itemOrder: number,
        deleted: boolean,
        eventTypeGroupSequenceIdentity: string
    ): DropdownItem {
        const item = new DropdownItem(dropdownItemId, dropdownGroupId, name, itemOrder, deleted, []);
        item.eventTypeGroupSequenceIdentity = eventTypeGroupSequenceIdentity;
        return item;
    }
}
